import React from 'react';
import type { AnalyticsDayPartLike, AnalyticsLayoutLike } from '../../analytics/sdmAdoptionMetrics';
import { useSDMAdoptionSnapshot } from '../../hooks/useSDMAdoptionSnapshot';
import { useServiceDisplayDayParts } from '../../hooks/useServiceDisplayDayParts';

interface SDMAdoptionTrackerProps {
  layouts: ReadonlyArray<AnalyticsLayoutLike> | undefined;
}

/**
 * Headless component that reports the customer's SDM adoption census.
 */
const SDMAdoptionTracker: React.FC<SDMAdoptionTrackerProps> = ({ layouts }) => {
  const { data: dayParts } = useServiceDisplayDayParts();

  useSDMAdoptionSnapshot(layouts, dayParts as AnalyticsDayPartLike[] | undefined);

  return null;
};

export default React.memo(SDMAdoptionTracker);
